import { ACL_TYPE } from '@openx/types/aclType';
import { usePermissionContext } from '@openx/utils/permission/context/PermissionContext';
import { isAllowedByCompiledAcl } from '@openx/utils/permission/validators';

export function useCanCreateAmazonMarketplaceDeal(): boolean {
  const { useIsAllowed } = usePermissionContext();
  const { isAllowed } = useIsAllowed();

  return isAllowed(isAllowedByCompiledAcl(ACL_TYPE.DEAL_AMAZON_MARKETPLACE_ENABLED));
}
